import script from "./CardReceivablesListPage.vue?vue&type=script&setup=true&lang=js"
export * from "./CardReceivablesListPage.vue?vue&type=script&setup=true&lang=js"

import "./CardReceivablesListPage.vue?vue&type=style&index=0&id=0780113b&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0780113b"]])

export default __exports__